export default function (timeInMilliseconds: number) {
  return new Promise<void>((res) => {
    setTimeout(() => {
      res();
    }, timeInMilliseconds);
  });
}
